import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Apollo } from 'apollo-angular';
import { EMPTY, ReplaySubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Timezone } from './timezone.model';
import { TimezonesQuery, TIMEZONES_QUERY } from './timezones.graphql';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  _timezones$: ReplaySubject<Timezone[]> = new ReplaySubject(1);

  constructor(private apollo: Apollo, private snackBar: MatSnackBar) {
    this.apollo
      .default()
      .query<TimezonesQuery>({
        query: TIMEZONES_QUERY,
        variables: { sorting: { id: 'ASC' } },
        fetchPolicy: 'no-cache',
      })
      .pipe(map((result) => result.data.timezones))
      .subscribe(this._timezones$);

    this._timezones$.subscribe({
      error: (err) => {
        const message = $localize`There was an unexpected error.`;
        this.snackBar.open(message, $localize`Close`, { duration: 10000 });
        throw err;
      },
    });
  }

  get timezones$() {
    return this._timezones$.pipe(catchError(() => EMPTY));
  }
}
